import styled from 'styled-components';

export const Container = styled.div(({ theme }) => ({
  textAlign: 'center',
  fontFamily: theme.typography.family.arial,

  [theme.breakpoint.media.max.md]: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    textAlign: 'start',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
}));

export const Title = styled.h4(({ theme }) => ({
  fontSize: theme.typography.size16,
  color: theme.palette.darkLiver,
  textTransform: 'uppercase',
  fontWeight: 400,

  [theme.breakpoint.media.max.md]: {
    marginBottom: '0.5rem',
  },
}));

export const Description = styled.p(({ theme }) => ({
  fontSize: theme.typography.size12,
  color: theme.palette.erieBlack,
}));

export const Link = styled.a(({ theme }) => ({
  textDecoration: 'underline',
  color: theme.palette.tuftsBlue,
}));

export const Content = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '20rem',
  maxWidth: '80%',
});
